module.exports = __webpack_public_path__ + "static/media/download-file.eac7d43f.svg";